import { render } from "./DialogGroup.vue?vue&type=template&id=65a47468"
import script from "./DialogGroup.vue?vue&type=script&lang=js"
export * from "./DialogGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__